import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "completion-accordion__summary" }
const _hoisted_3 = { class: "completion-accordion__title" }
const _hoisted_4 = {
  key: 0,
  class: "completion-accordion__divider"
}
const _hoisted_5 = { class: "completion-accordion__content" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompletionAccordion',
  props: {
    title: {},
    defaultOpen: { type: Boolean, default: false },
    showDivider: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const isOpen = ref(props.defaultOpen)

function onToggle(event: Event): void {
  isOpen.value = (event.currentTarget as HTMLDetailsElement).open
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", {
    class: "completion-accordion",
    open: isOpen.value,
    onToggle: onToggle
  }, [
    _createElementVNode("summary", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "badge"),
      _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "completion-accordion__chevron",
        "aria-hidden": "true"
      }, [
        _createElementVNode("span", { class: "iconfont iarrow-down" })
      ], -1))
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.showDivider)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})